import React, { Component } from 'react';
import Comment from './Comment/Comment';
import './Discussion.css';
import { fetchDetailMessages } from '../../../../../../api';
import { PATH } from '../../../../../../constants';

const SHOW_LIMIT = 2;

class Discussion extends Component {
  constructor(props) {
    super(props);

    this.state = {
      msgData: [],
      closed: true,
    };

    this.handleArrowClick = this.handleArrowClick.bind(this);
  }

  // -----------------------------------------------------------------------------------
  // Lifecycle
  // -----------------------------------------------------------------------------------

  componentDidMount() {
    this.dataUpdate();
  }

  componentDidUpdate(prevProps) {
    const { detailId, msgCount } = this.props;
    if (detailId !== prevProps.detailId || msgCount !== prevProps.msgCount) {
      this.dataUpdate();
    }
  }

  // -----------------------------------------------------------------------------------
  // Data
  // -----------------------------------------------------------------------------------

  dataUpdate() {
    const { msgCount, detailId } = this.props;
    if (msgCount > 0) {
      fetchDetailMessages(detailId)
        .then(msgData => {
          this.setState({
            msgData,
            closed: true,
          });
        })
        .catch(() => {
          // note - should handle error
        });
    }
  }

  // -----------------------------------------------------------------------------------
  // Handlers
  // -----------------------------------------------------------------------------------

  handleArrowClick() {
    this.setState({
      closed: false,
    });
  }

  // -----------------------------------------------------------------------------------
  // Render
  // -----------------------------------------------------------------------------------

  render() {
    const { closed, msgData } = this.state;
    const { onVideoSeek } = this.props;
    const dataCount = msgData.length;
    const canClose = dataCount > SHOW_LIMIT;
    const anyMsg = dataCount > 0;

    const comments = msgData.map(data => (
      <Comment key={data.id} data={data} onVideoSeek={onVideoSeek} />
    ));
    const visibleComments = canClose && closed ? SHOW_LIMIT : comments.length;

    return (
      <React.Fragment>
        {anyMsg && (
          <div id="discuss">
            <div>{comments.splice(0, visibleComments)}</div>
            {canClose &&
              closed && (
                <div id="discuss-menu-wrap">
                  <button
                    id="discuss-btn"
                    type="button"
                    onClick={this.handleArrowClick}
                  >
                    <img alt="" src={`${PATH.IMG}ico/arrow.png`} />
                    <div id="dis-msg-count">
                      <img
                        className="bg"
                        src={`${PATH.IMG}deco/msg-count.png`}
                        alt=""
                      />
                      <div className="number">{dataCount}</div>
                    </div>
                  </button>
                </div>
              )}
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default Discussion;



// WEBPACK FOOTER //
// ./src/components/App/Okupace/Content/Detail/Discussion/Discussion.js